import { PaymentState } from 'scenes/payments/types';
import { ApiState } from 'scenes/common/helpers/apiData/types';
import { PaymentActions } from './paymentTypes';

export type ReduxAction = {
  type: string;
  payload: Partial<PaymentState>;
};

const initialState = {
  loadingStatus: ApiState.NeverLoaded,
  error: null,
  address: null,
  coverType: '',
  product: '',
  postcode: '',
  policy: {
    number: '',
    reference: '',
    status: '',
    dates: {
      inception: '',
      expiry: '',
      effective: '',
    },
    renewalStatus: '',
    otherDetails: {
      description: '',
      risk: '',
      office: '',
      eDoc: true,
    },
    payment: {
      paymentMethod: null,
      paymentWhen: null,
      receipt: '',
    },
  },
};

const paymentReducer = (state = initialState, action: ReduxAction) => {
  switch (action.type) {
    case PaymentActions.UPDATE_RESPONSE:
      return {
        ...state,
        ...action.payload,
      };
    case PaymentActions.UPDATE_LOADING_STATUS:
      return {
        ...state,
        loadingStatus: action.payload,
      };
    case PaymentActions.UPDATE_ERROR:
      return {
        ...state,
        error: action.payload,
      };

    case PaymentActions.UPDATE_PAYMENT:
      return {
        ...state,
        ...action.payload,
      };
    case PaymentActions.RESET_PAYMENT:
      return initialState;
    default:
      return state;
  }
};

export default paymentReducer;
